import React from "react";
import loadable from "@loadable/component";
import Loading from "../../Loading";

const LoadableComponent = loadable(() => import("../../../students/offers/BasicSearch"), {
  fallback: (() => <Loading />)(),
});

const Component = () => <LoadableComponent />;

export default Component;
